import { NavigationMenuSelection } from "../../../interfaces/navigation_menu.interface";
import { normalizeNavigationSourceSelection } from "../../../utils/navigation_source_selection.util";

export interface RequirementFollowUpLink {
    appendixLabel: string;
    responseLabel: string;
    targetSelection: NavigationMenuSelection;
}


interface FollowUpLinkConfigEntry {
    sectionId: string;
    appendixLabel: string;
    responseLabel: string;
}

const FOLLOW_UP_LINK_CONFIG: Record<number, FollowUpLinkConfigEntry> = {
    2: {
        sectionId: "appendix_b",
        appendixLabel: "Appendix B",
        responseLabel: "In Place with CCW"
    },
    3: {
        sectionId: "appendix_c",
        appendixLabel: "Appendix C",
        responseLabel: "Not Applicable"
    },
    4: {
        sectionId: "appendix_d",
        appendixLabel: "Appendix D",
        responseLabel: "Not Tested"
    }
};

export function buildFollowUpLink(
    option: number | null,
    resolveTargetRequirementKey: (sectionId: string) => string | null,
    sourceSelection?: NavigationMenuSelection | null
): RequirementFollowUpLink | null {
    if (option === null) {
        return null;
    }

    const config = FOLLOW_UP_LINK_CONFIG[option];
    if (!config) {
        return null;
    }

    const target = resolveTargetRequirementKey(config.sectionId);
    if (!target) {
        return null;
    }

    const normalizedSourceSelection = normalizeNavigationSourceSelection(sourceSelection);

    return {
        appendixLabel: config.appendixLabel,
        responseLabel: config.responseLabel,
        targetSelection: {
            section: config.sectionId,
            target,
            sourceSelection: normalizedSourceSelection
        }
    };
}
